 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML04_COPYRIGHT from '@/components/xhtml/04_Copyright'
 import XHTML03_TITLE_PAGE from '@/components/xhtml/03_Title_Page'
 import XHTML02_FRONTISPIECE from '@/components/xhtml/02_Frontispiece'
 import XHTML05_DEDICATION from '@/components/xhtml/05_Dedication'
 import XHTML06_EPIGRAPH from '@/components/xhtml/06_Epigraph'
 import XHTML07_CONTENTS from '@/components/xhtml/07_Contents'
 import XHTML08_ILLUSTRATIONS from '@/components/xhtml/08_Illustrations'
 import XHTML09_ACKNOWLEDGMENTS from '@/components/xhtml/09_Acknowledgments'
 import XHTML10_ONE__OPENINGS from '@/components/xhtml/10_ONE__Openings'
 import XHTML11_INTRODUCTION__ON_WILD_FACTS_AND from '@/components/xhtml/11_Introduction__On_Wild_Facts_and'
 import XHTML12_TWO__GEOGRAPHIC__HISTORICAL__AND from '@/components/xhtml/12_TWO__Geographic__Historical__and'
 import XHTML13_1__SLATE_S_HOT_SPRINGS__HOMESTEA from '@/components/xhtml/13_1__Slate_s_Hot_Springs__Homestea'
 import XHTML14_THREE__THE_EMPOWERMENT_OF_THE_FO from '@/components/xhtml/14_THREE__The_Empowerment_of_the_Fo'
 import XHTML15_2__THE_PROFESSOR_AND_THE_SAINT from '@/components/xhtml/15_2__The_Professor_and_the_Saint'
 import XHTML16_3__BUDDHISM__BREAKDOWN__BREAKTHR from '@/components/xhtml/16_3__Buddhism__Breakdown__Breakthr'
 import XHTML17_FOUR__THE_OUTLAW_ERA_AND_THE_AME from '@/components/xhtml/17_FOUR__The_Outlaw_Era_and_the_Ame'
 import XHTML18_4___TOTALLY_ON_FIRE___THE_EXPERI from '@/components/xhtml/18_4___Totally_on_Fire___The_Experi'
 import XHTML19_5__MIND_MANIFEST__PSYCHEDELIA_AT from '@/components/xhtml/19_5__Mind_Manifest__Psychedelia_at'
 import XHTML20_6__MESMER_TO_MASLOW__ENERGY_AND from '@/components/xhtml/20_6__Mesmer_to_Maslow__Energy_and'
 import XHTML21_7__PERLS_TO_PRICE__CONSCIOUSNESS from '@/components/xhtml/21_7__Perls_to_Price__Consciousness'
 import XHTML22_8__ESALEN_GOES_TO_THE_CITY__THE from '@/components/xhtml/22_8__Esalen_Goes_to_the_City__The'
 import XHTML23_9__ON_ECSTASY__EDUCATION__AND_TH from '@/components/xhtml/23_9__On_Ecstasy__Education__and_th'
 import XHTML24_10__THE_SERPENT_SPINE_OF_SPIRIT from '@/components/xhtml/24_10__The_Serpent_Spine_of_Spirit'
 import XHTML25_FIVE__THE_OCCULT_IMAGINAL_AND_CO from '@/components/xhtml/25_FIVE__The_Occult_Imaginal_and_Co'
 import XHTML26_11__THE_COSMIC_WOMB__STANISLAV_A from '@/components/xhtml/26_11__The_Cosmic_Womb__Stanislav_a'
 import XHTML27_12__GOLF_IN_THE_KINGDOM__PLATO_A from '@/components/xhtml/27_12__Golf_in_the_Kingdom__Plato_a'
 import XHTML28_13__JACOB_ATABET_AND_THE_TANTRA from '@/components/xhtml/28_13__Jacob_Atabet_and_the_Tantra'
 import XHTML29_14__SUPERPOWERS__COLD_WAR_PSYCHI from '@/components/xhtml/29_14__Superpowers__Cold_War_Psychi'
 import XHTML30_15__SEX_WITH_THE_ANGELS__NONLOCA from '@/components/xhtml/30_15__Sex_with_the_Angels__Nonloca'
 import XHTML31_16__THE_TAO_OF_ESALEN__THE_SPIRI from '@/components/xhtml/31_16__The_Tao_of_Esalen__The_Spiri'
 import XHTML32_SIX__CRISIS_AND_THE_RELIGION_OF from '@/components/xhtml/32_SIX__Crisis_and_the_Religion_of'
 import XHTML33_17__THE_RELIGION_OF_NO_RELIGION from '@/components/xhtml/33_17__The_Religion_of_No_Religion'
 import XHTML34_18__REALIZING_DARWIN_S_DREAM__TH from '@/components/xhtml/34_18__Realizing_Darwin_s_Dream__Th'
 import XHTML35_SEVEN__BEFORE_AND_AFTER_THE_STOR from '@/components/xhtml/35_SEVEN__Before_and_After_the_Stor'
 import XHTML36_19__AFTER_THE_STORM__REASSESSMEN from '@/components/xhtml/36_19__After_the_Storm__Reassessmen'
 import XHTML37_IN_CONCLUSION__THE_FUTURE_OF_TH from '@/components/xhtml/37_IN_CONCLUSION__The_Future_of_th'
 import XHTML38_ABBREVIATIONS from '@/components/xhtml/38_Abbreviations'
 import XHTML39_NOTES from '@/components/xhtml/39_Notes'
 import XHTML40_ON_RARE_THINGS__THE_ORAL__VISUAL from '@/components/xhtml/40_On_Rare_Things__The_Oral__Visual'
 import XHTML41_INDEX from '@/components/xhtml/41_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/07_Contents",
 			"name" : "xhtml/07_Contents",
 			"component" : XHTML07_CONTENTS
 		},
 		{
 			"path" : "/xhtml/08_Illustrations",
 			"name" : "xhtml/08_Illustrations",
 			"component" : XHTML08_ILLUSTRATIONS
 		},
 		{
 			"path" : "/xhtml/09_Acknowledgments",
 			"name" : "xhtml/09_Acknowledgments",
 			"component" : XHTML09_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/10_ONE__Openings",
 			"name" : "xhtml/10_ONE__Openings",
 			"component" : XHTML10_ONE__OPENINGS
 		},
 		{
 			"path" : "/xhtml/11_Introduction__On_Wild_Facts_and",
 			"name" : "xhtml/11_Introduction__On_Wild_Facts_and",
 			"component" : XHTML11_INTRODUCTION__ON_WILD_FACTS_AND
 		},
 		{
 			"path" : "/xhtml/12_TWO__Geographic__Historical__and",
 			"name" : "xhtml/12_TWO__Geographic__Historical__and",
 			"component" : XHTML12_TWO__GEOGRAPHIC__HISTORICAL__AND
 		},
 		{
 			"path" : "/xhtml/13_1__Slate_s_Hot_Springs__Homestea",
 			"name" : "xhtml/13_1__Slate_s_Hot_Springs__Homestea",
 			"component" : XHTML13_1__SLATE_S_HOT_SPRINGS__HOMESTEA
 		},
 		{
 			"path" : "/xhtml/14_THREE__The_Empowerment_of_the_Fo",
 			"name" : "xhtml/14_THREE__The_Empowerment_of_the_Fo",
 			"component" : XHTML14_THREE__THE_EMPOWERMENT_OF_THE_FO
 		},
 		{
 			"path" : "/xhtml/15_2__The_Professor_and_the_Saint",
 			"name" : "xhtml/15_2__The_Professor_and_the_Saint",
 			"component" : XHTML15_2__THE_PROFESSOR_AND_THE_SAINT
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js